import { InjectionToken } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

export const KEYCLOAK = new InjectionToken<KeycloakService>('Keycloak service');
